/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Paper from '@mui/material/Paper';
import RestoreIcon from '@mui/icons-material/Restore';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DescriptionIcon from '@mui/icons-material/Description';

function ButtomBar() {
  const { pathname } = window.location;
  const [value, setValue] = React.useState(pathname);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="lg:hidden">
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
        }}
        elevation={7}
      >
        {/* <BottomNavigation value={value} onChange={handleChange} showLabels>
          <BottomNavigationAction
            label="Transaction"
            value="/show-invoice"
            icon={<DescriptionIcon />}
            component={Link}
            to="/transaction-collection"
          />
          <BottomNavigationAction
            label="รายการรอจ่าย"
            value="/payment-list-user"
            icon={<AccessTimeIcon />}
            component={Link}
            to="/payment-list-user"
          />
          <BottomNavigationAction
            label="ประวัติการชำระเงิน"
            value="/payment-list-user"
            icon={<RestoreIcon />}
            component={Link}
            to="/payment-list-user"
          />
          <BottomNavigationAction
            label="อัปโหลดหลักฐาน"
            value="/setting"
            icon={<UploadFileIcon />}
            component={Link}
            to="/setting"
          />
        </BottomNavigation> */}
      </Paper>
    </div>
  );
}

export default ButtomBar;
